module.exports = __webpack_public_path__ + "img/headMap.78376399.png";